export const saveIcon = { size: '19', color: '#000B' };
export const deleteIcon = { size: '18', color: '#000B' };
